module.exports = __webpack_public_path__ + "img/icon_enjoy03@2x.f953e652.png";